export default __webpack_public_path__ + "static/media/pig staking 1.2de9e757.svg";